import * as React from 'react';
import { useRoute } from 'react-router5'; 
import { Layout } from '../components/Layout/Layout';
// import { AppState, AuthenticatedUser, DEFAULT_APP_STATE } from '../state/app-state'; 
import { setDeep } from '../util/setDeep';
//import { LoginContainer } from './Login.container';
import { ViewContainer } from './view.container';


export const AppContainer: React.FC<Props> = (props) => {
    const route = useRoute();
    const [hasAttemptedCookieAuth, setHasAttemptedCookieAuth] = React.useState(false);
    // const [state, setState] = React.useState<AppState>(DEFAULT_APP_STATE());
    // const stateRef = React.useRef<AppState>(state);

    // const invalidateToken = () => {
    //     setState({ ...DEFAULT_APP_STATE() });
    //     stateRef.current = { ...DEFAULT_APP_STATE() };
    // }

    // const testUser: AuthenticatedUser = {
    //     fullName: "test account",
    //     email: "what@who.com",
    //     url: ''
    // }

    /**
     * Every async state change from a loadable comes in through this
     * callback.  The ref seems to be required to get an updated version of the state, otherwise
     * the version of state when the callback was created is used.
     */
    // const handleStateChange = React.useCallback(<T,>(loadable: Loadable<T>) => {
    //     if (!stateRef.current) {
    //         return;
    //     }
    //     console.log("NEXT", loadable);
    //     const nextState = { ...stateRef.current };
    //     setDeep(nextState, loadable.PROPERTY_NAME, loadable);

    //     setState(nextState);
    //     stateRef.current = nextState;
    // }, [stateRef, state])
  

    return (
        <div className="app-container">
          <Layout>
            <div style={{minHeight:"100vh"}}>
                <ViewContainer/></div>
            </Layout>   
        </div>
    )
}



interface Props {

}